import { Action, createReducer, on } from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {QueryParamsModel} from "../../_base/crud";
import * as ParcelActions from "../_actions/parcel.actions";
import {ParcelStateModel} from "../_models/parcelState";



export const parcelStatesFeatureKey = 'parcelStates';

export interface ParcelStatesState extends EntityState<ParcelStateModel> {
    listLoading: boolean;
    actionsLoading: boolean;
    lastQuery: QueryParamsModel;
    totalCount: number;
    showInitWaitingMessage: boolean;
    error: any;
    errorMessage: string;
    lastAction: string;
    progress: number;
}

export const adapter: EntityAdapter<ParcelStateModel> = createEntityAdapter<ParcelStateModel>();

export const initialParcelState: ParcelStatesState = adapter.getInitialState({
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    lastQuery: new QueryParamsModel({}),
    showInitWaitingMessage: true,
    error: Response,
    errorMessage: '',
    lastAction: '',
    progress: 0
});


export const parcelStatesReducer = createReducer(
    initialParcelState,

    on(ParcelActions.loadParcelStates,
        (state, action) => ({
            ...state,
            actionsLoading: true,
            listLoading: true,
            showInitWaitingMessage: true,
            error: null,
            lastAction: ''

        })),
    on(ParcelActions.loadParcelStatesSuccess,
        (state, action) =>
            (adapter.addAll(
                action.data,
                {
                    ...state,
                    actionsLoading: false,
                    listLoading: false,
                    showInitWaitingMessage: false,
                    totalCount: action.data.length
                }))),
    on(ParcelActions.loadParcelStatesFailure,
        (state, action) => ({
            ...state,
            actionsLoading: true,
            listLoading: false,
            showInitWaitingMessage: false,
            error: action.error
        })),

);

export function ParcelStatesReducer(state: ParcelStatesState | undefined, action: Action) {
    return parcelStatesReducer(state, action)
}

